// extracted by mini-css-extract-plugin
module.exports = {"StartPage":"StartPage_StartPage__2ciH4"};